import { Component, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ReliabilityAssessmentService } from '../../services/reliability-assessment.service';

@Component({
  selector: 'app-step2',
  templateUrl: './step2.page.html',
  styleUrls: ['./step2.page.scss'],
})
export class WeeklyEvaluationStep2 {
  public form: UntypedFormGroup;

  // option list for the radio group
  radioGroupOptions = [
    { id: true, name: 'Yes' },
    { id: false, name: 'No' },
  ];

  @Input() lateOrNoSessions = [];

  @Input() assessmentValue: { scheduledSessions: number; noShows: number };

  constructor(
    public fb: UntypedFormBuilder,
    public modalCtrl: ModalController,
    public assessmentService: ReliabilityAssessmentService,
  ) {
    this.setupFormFields();
  }

  /**
   * setup form fields
   */
  setupFormFields() {
    this.form = this.fb.group({
      isOnTime: [true],
      lateArrivals: [''],
      incompleteTasks: [''],
      otherFeedback: [''],
    });
  }

  /**
   * Close modal and submit value back to parent modal
   */
  Submit() {
    const reqData = {
      isOnTime: this.form.value.isOnTime,
      lateArrivals: this.form.value.lateArrivals ? this.form.value.lateArrivals : 0,
      incompleteTasks: this.form.value.incompleteTasks ? this.form.value.incompleteTasks : 0,
      otherFeedback: this.form.value.otherFeedback,
    };
    this.modalCtrl.dismiss(reqData);
  }
}
